import { atomWithStorage } from 'jotai/utils';

const createStationFilterAtom = (key: string) => atomWithStorage<string[]>(key, [], undefined, { getOnInit: true });

export type StationFilterAtom = ReturnType<typeof createStationFilterAtom>;

export const observationFilterState = createStationFilterAtom('wxObservationStations');
export const advisoryFilterState = createStationFilterAtom('wxAdvisoryStations');
